<template>
  <div class="l-m-scenery">
    <!-- 新增场景 选项 弹框 -->
    <el-dialog
      :title="configTitle"
      custom-class="add-scene-dialog"
      v-model="centerDialogVisible"
      width="30%"
      @close="handleConfigorDialogClosed"
      center
    >
      <div class="scene-name-configor">
        <p>场景名称</p>
        <el-input placeholder="请输入场景名称" type="text" maxlength="10" v-model="sceneName"></el-input>
      </div>
      <div class="scene-sort-configor">
        <div class="sort">
          <span>场景排序索引</span>
          <el-input
            class="sort-index"
            placeholder="请输入索引值"
            type="text"
            maxlength="10"
            v-model="sceneSortIndex"
          ></el-input>
        </div>
      </div>
      <div class="scene-bk-configor">
        <div>
          当前选中背景为
          <!-- <el-form-item> -->
          <el-select v-model="selectBackground" value-key="componentTitle" placeholder="请选择背景">
            <el-option
              v-for="val in allBackgroundData"
              :key="val.id"
              :label="val.componentTitle"
              :value="val"
            ></el-option>
          </el-select>
          <!-- </el-form-item> -->
        </div>
        <!-- @change="changeSetting" -->
        <el-switch v-model="isChangeBk" active-color="#1989fa" size="mini" inactive-color="#333"> </el-switch>
      </div>
      <div class="scene-like-configor">
        <div class="like-center">
          当前是否为外链场景
          <el-switch v-model="isChangelink" active-color="#1989fa" size="mini" inactive-color="#333">
          </el-switch>
          <div>
            <el-input
              placeholder="请输入外链地址"
              type="text"
              v-if="isChangelink"
              maxlength="10000"
              v-model="linkUrl"
            ></el-input>
          </div>
          <div v-if="isChangelink">
            <el-radio v-model="jumpTo" label="cpage">当前页面</el-radio>
            <el-radio v-model="jumpTo" label="opage">外跳页面</el-radio>
          </div>
        </div>
      </div>
      <div class="scene-name-configor">
        <p>场景描述</p>
        <el-input placeholder="请输入当前场景的描述" type="text" v-model="sceneDesc"></el-input>
      </div>
      <div class="scene-icon-configor">
        <span>场景图标路径</span>
        <el-input
          placeholder="请输入icon图片资源的路径"
          type="text"
          maxlength="1000"
          v-model="sceneIcon"
        ></el-input>
      </div>
      <div>选择场景图标</div>
      <div class="menus-icon-selector">
        <div
          @click="changeMenuIcon(item)"
          class="menus-icon-item"
          :class="{ active: item === sceneIcon }"
          v-for="item in menusIconList"
          :key="item"
        >
          <img :src="item" alt="" />
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="addScene">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 左侧 场景管理 -->
    <div class="header">场景管理</div>
    <div class="body" :style="getHeightStyle()">
      <div
        class="item"
        v-for="(item, index) in ProjectInfo.SceneryList"
        :key="index"
        @click="handleSelectScene(item.id)"
      >
        <i class="edit-scene el-icon-edit" @click="handleEditScene($event, item)"></i>
        <div class="item-img" :class="{ active: ProjectInfo.CurrentScene.id === item.id }" draggable="false">
          <img class="img" :src="item.OverViewImg" alt="" />
        </div>
        <div class="item-name">{{ item.SceneName }}</div>
      </div>
      <div class="add-scene-container">
        <el-button type="primary" size="mini" @click="openAddSceneDialog">添加新的场景</el-button>
        <el-button type="warning" size="mini" @click="delScene(currentScreenId)">删除当前场景</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { nanoid } from 'nanoid';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'LMScenery',
  porps: {
    ProjectInfo: Object,
  },
  data() {
    return {
      isEditMode: false,
      configTitle: '添加场景',
      currentScreenId: 'scene_default',
      centerDialogVisible: false,
      sceneName: '',
      sceneDesc: '',
      sceneIcon: './img/styles/menusIcons/menuIcon1.png',
      menusIconList: [],
      isChangeBk: false,
      isChangelink: false,
      jumpTo: 'cpage',
      linkUrl: '',
      currentEditScene: null,
      value: {},
      allSceneData: {},
      selectBackground: {},
      sceneSortIndex: 0, // 排序索引值
      // list: []
    };
  },
  created() {
    this.initMenusIconList();
  },
  mounted() {
    this.allBackgroundData = this.BackgroundsList; // 所有 场景数据
  },
  watch: {
    selectBackground: {
      deep: true,
      handler: function (newVal) {
        console.log(newVal, 'selectBackground');
      },
    },
  },
  computed: {
    ...mapState({
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
      SceneryList: state => state.ProjectInfo.SceneryList,
      BackgroundsList: state => state.BackgroundsList, // 所有 背景 数据
    }),
    newSceneryList() {
      return this.ProjectInfo.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
  methods: {
    ...mapMutations([
      'set_CurrentScene',
      'add_SceneToSceneryList',
      'del_SceneFromSceneryList',
      'mod_SceneOfSceneryListById',
      'set_ProjectBackground',
      'set_CurrentConfigration',
    ]),
    handleConfigorDialogClosed() {
      console.log('对话框关闭');
      this.isEditMode = false;
      this.sceneIcon = './img/styles/menusIcons/menuIcon1.png';
      this.sceneName = '';
      this.sceneDesc = '';
      this.isChangeBk = false;
    },
    commitModifyScene() {
      if (this.currentEditScene) {
        const Mod = {
          id: this.currentEditScene.id,
          modConfig: {
            sceneIcon: this.sceneIcon,
            sceneName: this.sceneName,
            sceneDesc: this.sceneDesc,
            Background: this.selectBackground,
            isChangeBk: this.isChangeBk,
            isChangelink: this.isChangelink,
            jumpTo: this.jumpTo,
            linkUrl: this.linkUrl,
            sceneSortIndex: this.sceneSortIndex,
          },
        };
        console.log(Mod, 'Mod 修改信息');

        this.mod_SceneOfSceneryListById(Mod);
        this.$ElMessage.success('修改成功！');
        this.sceneIcon = './img/styles/menusIcons/menuIcon1.png';
        this.sceneName = '';
        this.sceneDesc = '';
        this.selectBackground = this.selectBackground;
        this.isChangeBk = false;
        this.isChangelink = false;
        this.jumpTo = 'cpage';
        this.linkUrl = '';
        this.centerDialogVisible = false;
      }
    },
    handleEditScene(e, scene) {
      console.log(scene, '544544545454');
      e.stopPropagation();
      this.configTitle = '修改场景';
      this.currentEditScene = scene;
      this.sceneName = scene.SceneName;
      this.sceneDesc = scene.SceneDesc;
      this.sceneIcon = scene.IconPath;
      this.selectBackground = scene.Background;
      this.isChangeBk = scene.isChangeBk;
      this.isChangelink = scene.isChangelink;
      this.jumpTo = scene.jumpTo;
      this.linkUrl = scene.linkUrl;
      this.sceneSortIndex = scene.sceneSortIndex;
      this.centerDialogVisible = true;
      // 切换编辑模式
      this.isEditMode = true;
    },
    changeMenuIcon(icon) {
      this.sceneIcon = icon;
    },
    initMenusIconList() {
      let pre = './img/styles/menusIcons/';
      const files = require.context('@public/img/styles/menusIcons', false, /\.png$/);
      for (let i = 1; i < files.keys().length + 1; i++) {
        this.menusIconList.push(`${pre}menuIcon${i}.png`);
      }
    },
    getHeightStyle() {
      return {
        height: this.$store.state.ClientViewSize.height - 80 + 'px',
      };
    },
    handleSelectScene(id) {
      this.set_CurrentScene(id);
      this.currentScreenId = id;
    },
    openAddSceneDialog() {
      this.configTitle = '添加场景';
      this.centerDialogVisible = true;
      this.sceneSortIndex = this.ProjectInfo.SceneryList.length + 1;
      this.$forceUpdate();
    },
    addScene() {
      if (this.isChangelink == true && this.linkUrl == '') {
        this.$ElMessage.error('外链地址不可为空！');
        return;
      }
      if (this.isEditMode) {
        this.commitModifyScene();
        return;
      }
      if (this.sceneName.length < 1) {
        this.$ElMessage.error('场景昵称不可为空！');
        return;
      }
      let bakData = this.selectBackground;
      let id = nanoid();
      function getPath(path) {
        let index = path.lastIndexOf('/');
        return `./img/styles/menusIcons/active${path.substring(index)}`;
      }
      let add_Scene = {
        id,
        IconPath: `${this.sceneIcon.trim()}`, // 底部 button 图标
        IconActivePath: getPath(this.sceneIcon), // 底部 button 图标
        OverViewImg: './img/scene/scene.png',
        SceneName: `${this.sceneName.trim()}`,
        SceneDesc: `${this.sceneDesc.trim()}`,
        Background: bakData, // 选中 背景 数据
        Style: {},
        Charts: [],
        // 开启选中的背景
        isChangeBk: this.isChangeBk,
        isChangelink: this.isChangelink,
        jumpTo: this.jumpTo,
        linkUrl: this.linkUrl,
        sceneSortIndex: Number(this.sceneSortIndex),
      };

      this.add_SceneToSceneryList(add_Scene);
      console.log(add_Scene, 'add_Scene add_Scene');
      if (this.isChangeBk === true) {
        if (add_Scene.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        } else {
          this.set_ProjectBackground(add_Scene.Background);
          this.set_CurrentConfigration(add_Scene.Background);
        }
        // console.log(this.ProjectInfo.SceneryList, 'this.ProjectInfo.SceneryList');
        // let SceneryList = JSON.parse(JSON.stringify(this.ProjectInfo.SceneryList))
        // console.log(SceneryList, 'SceneryList');
        // localStorage.setItem('SceneryList', JSON.stringify(SceneryList))
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        this.set_ProjectBackground(backgroundDefault);
        this.set_CurrentConfigration(backgroundDefault);
      }
      this.centerDialogVisible = false;
      this.set_CurrentScene(id);
      this.currentScreenId = id;
      this.sceneName = '';
      this.sceneDesc = '';
      this.selectBackground = {};
      this.isChangeBk = false;
      this.isChangelink = false;
      this.isChangelink = '';
      this.linkUrl = '';
      this.sceneIcon = './img/styles/menusIcons/menuIcon1.png';
    },
    delScene(Id) {
      if (this.ProjectInfo.SceneryList.length < 2) {
        this.$ElMessage.error(`请保留至少一个场景！`);
        return;
      }
      this.del_SceneFromSceneryList(Id);
    },
  },
};
</script>

<style lang="scss" scoped>
.l-m-scenery {
  width: 240px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  :deep().add-scene-dialog {
    .scene-name-configor {
      margin-bottom: 10px;
    }
    .scene-icon-configor {
      margin-bottom: 10px;
    }
    .scene-sort-configor {
      margin-bottom: 10px;

      .sort {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        // flex-basis: 120px;
        .el-input.sort-index {
          width: 100px;
          margin-left: 10px;
          .el-input__inner {
            width: 100px !important;
          }
        }
      }
    }
    .scene-bk-configor {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          display: inline-block;
          color: #e36a2e;
          font-style: italic;
        }
      }
      .el-input {
        width: 84%;
      }
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .scene-like-configor {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;
      .like-center {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .menus-icon-selector {
      margin-top: 10px;
      padding: 10px 5px;
      height: 200px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      background-color: rgb(41, 41, 58);
      overflow-y: scroll;
      &::-webkit-scrollbar-thumb {
        background: #191e29 !important;
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar {
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar-track {
        background: #43455800;
      }
      .menus-icon-item {
        cursor: pointer;
        flex-shrink: 0;
        margin-left: 7px;
        margin-bottom: 14px;
        width: 60px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .active {
        border: 1px solid rgb(151, 132, 255);
      }
    }
    max-width: 400px;
    background-color: $background-color-medium;
    .el-dialog__title {
      color: $font-color-base;
    }
    .el-dialog__body {
      padding-top: 10px;
      color: $font-color-base;
    }
    .el-button {
      // padding: 0 10px;
      border-radius: 5px;
      color: #b6b8cc;
      border: 0;
      background: #2c2e3f;
      margin: 0 20px;
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
      }
    }
  }
  :deep().el-input input {
    height: 35px;
    color: #b6b8cc;
    background: rgb(26, 26, 26);
    text-align: center;
    border: 1px solid rgba(139, 139, 139, 0.733);
  }
  .header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    color: $font-color-base;
    user-select: none;
    background-color: #2c2e3f;
  }

  .body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;

    padding: 20px 0px 50px 0px;
    &::-webkit-scrollbar-thumb {
      background: #191e29 !important;
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar-track {
      background: #43455800;
    }

    .item-list {
      margin-bottom: 100px;
    }

    .item {
      position: relative;
      &:hover > .edit-scene {
        color: #ccc;
        // box-shadow: 1px 1px 4px 1px #191e29b4;
        background-color: #191e2900;
      }
      &:hover > .item-img {
        // border: 1px solid rgb(70, 59, 226);
      }

      .edit-scene {
        cursor: pointer;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #00000000;
        top: 4px;
        right: 22px;
        position: absolute;
        &:hover {
          color: #ccc;
          box-shadow: 1px 1px 4px 1px #191e29b4;
          background-color: #0f11166b;
        }
      }
      margin: 0 auto;
      // background-color: rosybrown;
      width: 100%;
      height: 160px;
      // margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-img {
        overflow: hidden;
        cursor: pointer;
        width: 202px;
        height: 128px;
        box-sizing: border-box;
        background-color: rgba(20, 20, 27, 0.733);
        border: 1px solid rgba(0, 0, 0, 0);
        transition: border 0.2s;
        border-radius: 5px;

        .img {
          width: 202px;
          height: 128px;
        }
      }
      .active {
        border: 1px solid rgb(70, 59, 226);
      }
      .item-name {
        user-select: none;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: $font-color-base;
      }
    }
    .add-scene-container {
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        // padding: 0 10px;
        border-radius: 5px;
        color: #b6b8cc;
        border: 0;
        background: #2c2e3f;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.425);
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: white;
        }
      }
    }
  }
}
:deep().el-switch {
  margin: auto 0;
  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;
    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }
  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);
      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}
</style>
